import { isEmpty } from '@/utils/immutable'

// Contract
export const getContractNumber = contract => contract?.data?.number
export const getContractDescription = contract => contract?.data?.object_description

export const getContractDate = contract => contract?.data?.dt_contract
export const getContractWorkDateStart = contract => contract?.data?.dt_work_start
export const getContractWorkDateEnd = contract => contract?.data?.dt_work_end

export const getContractOrganization = contract => contract?.partner_organization?.organization?.name
export const getContractOrganizationUser = contract => contract?.partner_organization?.organization?.organizations_projects[0]?.user
export const getContractOrganizationUserPosition = contract => contract?.partner_organization?.organization?.organizations_projects[0]?.position

export const getContractWorks = contract => contract?.works



// Work
export const getWorkNumber = work => work?.data?.smeta_number
export const getWorkName = work => work?.name 
export const getWorkType = work => work?.work_type?.name

export const getActualWorkFactUnits = work => work && work[[
  'fact_in_units_acceptance_of_work_second_stage_finished',
  'fact_in_units_acceptance_of_work_first_stage_finished', 
  'fact_in_units_acceptance_of_work_created'
].filter(x => !isEmpty(work[x]))[0]]



